// Generated by Melange

import * as Caml_js_exceptions from "melange.js/caml_js_exceptions.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Curry from "melange.js/curry.js";
import * as Js__Js_json from "melange.js/js_json.js";
import * as Mapre_chat__Chat_attachment from "../../shared/chat/chat_attachment.js";
import * as Mapre_wire__Json from "../../shared/wire/json.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Array from "melange/array.js";
import * as Stdlib__Hashtbl from "melange/hashtbl.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__String from "melange/string.js";

function keys(t) {
  return Stdlib__List.map((function (item) {
    return item.file.key;
  }), t.items);
}

function ready(t) {
  return Stdlib__List.for_all((function (item) {
    const match = item.status;
    if (/* tag */ typeof match !== "object" && typeof match !== "function" || match.TAG !== /* Ready */ 0) {
      return false;
    } else {
      return true;
    }
  }), t.items);
}

function references(t) {
  return Stdlib__List.filter_map((function (item) {
    const reference = item.status;
    if (/* tag */ typeof reference !== "object" && typeof reference !== "function" || reference.TAG !== /* Ready */ 0) {
      return;
    } else {
      return reference._0;
    }
  }), t.items);
}

function fields(references) {
  if (references) {
    return {
      hd: [
        "attachments",
        Stdlib__Array.of_list(Stdlib__List.map((function (reference) {
          return Mapre_wire__Json.str(reference.id);
        }), references))
      ],
      tl: /* [] */ 0
    };
  } else {
    return /* [] */ 0;
  }
}

function decode(json) {
  const id = Mapre_wire__Json.string(json, "id");
  const name = Mapre_wire__Json.string(json, "name");
  const media_type = Mapre_wire__Json.string(json, "media_type");
  const size = Mapre_wire__Json.integer(json, "size");
  const sha256 = Mapre_wire__Json.string(json, "sha256");
  if (id.length > 128 || !Stdlib__String.for_all((function (param) {
      if (param >= 65) {
        if (param > 96 || param < 91) {
          return param < 123;
        } else {
          return param === 95;
        }
      } else if (param >= 48) {
        return param < 58;
      } else {
        return param === 45;
      }
    }), id) || size < 1 || size > 10485760 || sha256.length !== 64 || !Stdlib__String.for_all((function (c) {
      if (c >= /* '0' */48 && c <= /* '9' */57) {
        return true;
      } else if (c >= /* 'a' */97) {
        return c <= /* 'f' */102;
      } else {
        return false;
      }
    }), sha256)) {
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_attachment"
      });
  }
  return {
    id,
    name,
    media_type,
    size,
    sha256
  };
}

function decode_list(value) {
  if (Caml_obj.caml_equal(value, null)) {
    return /* [] */ 0;
  }
  const values = Js__Js_json.decodeArray(value);
  if (values !== undefined) {
    if (values.length <= 8) {
      const seen = Stdlib__Hashtbl.create(undefined, 8);
      return Stdlib__Array.to_list(Stdlib__Array.map((function (value) {
        const reference = decode(value);
        if (Stdlib__Hashtbl.mem(seen, reference.id)) {
          throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
              MEL_EXN_ID: Mapre_wire__Json.Invalid,
              _1: "duplicate_attachment"
            });
        }
        Stdlib__Hashtbl.add(seen, reference.id, undefined);
        return reference;
      }), values));
    }
    throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
        MEL_EXN_ID: Mapre_wire__Json.Invalid,
        _1: "invalid_attachments"
      });
  }
  throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
      MEL_EXN_ID: Mapre_wire__Json.Invalid,
      _1: "invalid_attachments"
    });
}

function decode_selections(text) {
  const values = Js__Js_json.decodeArray(JSON.parse(text));
  if (values !== undefined) {
    return Stdlib__Array.to_list(Stdlib__Array.map((function (value) {
      return {
        key: Mapre_wire__Json.string(value, "key"),
        name: Mapre_wire__Json.string(value, "name"),
        media_type: Mapre_wire__Json.string(value, "media_type"),
        size: Mapre_wire__Json.integer(value, "size"),
        preview: Js__Js_json.decodeString(Mapre_wire__Json.get(value, "preview"))
      };
    }), values));
  }
  throw new Caml_js_exceptions.MelangeError(Mapre_wire__Json.Invalid, {
      MEL_EXN_ID: Mapre_wire__Json.Invalid,
      _1: "invalid_selection"
    });
}

function change(key, transform, t) {
  return {
    items: Stdlib__List.map((function (item) {
      if (item.file.key === key) {
        return Curry._1(transform, item);
      } else {
        return item;
      }
    }), t.items),
    message: t.message
  };
}

function update(t, files) {
  switch (files.TAG) {
    case /* Selected */ 0 :
      return {
        items: Stdlib.$at(t.items, Stdlib__List.map((function (file) {
          return {
            file,
            status: /* Uploading */ 0
          };
        }), files._0)),
        message: ""
      };
    case /* Uploaded */ 1 :
      const reference = files._1;
      return change(files._0, (function (item) {
        return {
          file: item.file,
          status: {
            TAG: /* Ready */ 0,
            _0: reference
          }
        };
      }), t);
    case /* Upload_failed */ 2 :
      const error = files._1;
      return change(files._0, (function (item) {
        return {
          file: item.file,
          status: {
            TAG: /* Failed */ 1,
            _0: error
          }
        };
      }), t);
    case /* Remove */ 3 :
      const key = files._0;
      return {
        items: Stdlib__List.filter((function (item) {
          return item.file.key !== key;
        }), t.items),
        message: ""
      };
    case /* Retry */ 4 :
      return change(files._0, (function (item) {
        return {
          file: item.file,
          status: /* Uploading */ 0
        };
      }), t);
    case /* Error */ 5 :
      return {
        items: t.items,
        message: files._0
      };
  }
}

const initial = {
  items: /* [] */ 0,
  message: ""
};

const image = Mapre_chat__Chat_attachment.image;

export {
  initial,
  update,
  ready,
  references,
  fields,
  keys,
  decode,
  decode_list,
  image,
  decode_selections,
}
/* Mapre_wire__Json Not a pure module */
